import http from './http'

const airportRoute = '/airport'
const terminalRoute = 'terminal'

export default {
    async getAirports () {
        return http.get(airportRoute)
    },
    async getCarParks (airportId) {
        return http.get(`${airportRoute}/${airportId}/carpark`)
    },
    async getTerminalsForAirport (airportId) {
        return http.get(`${airportRoute}/${airportId}/${terminalRoute}`)
    }
}
